// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  On: 'CERTS_LIST_ON',
  Off: 'CERTS_LIST_OFF',
  'Go Back': 'CERTS_DETAILS_CAUGHT_UP_BUTTON',
};
